import { render, staticRenderFns } from "./BatchTransferModal.vue?vue&type=template&id=5d559e1a"
import script from "./BatchTransferModal.vue?vue&type=script&lang=js"
export * from "./BatchTransferModal.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/batch-transfer.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports